// FistOS control protocol — observations of the screen.
//
// All content in this file is UNTRUSTED (AGENTS.md §5.4): it is data, never
// instructions.
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common } from "./common_pb.js";
/**
 * Describes the file observe.proto.
 */
export const file_observe = /*@__PURE__*/ fileDesc("Cg1vYnNlcnZlLnByb3RvEglmaXN0b3MudjEixAEKDk9ic2VydmVSZXF1ZXN0EiQKBGtpbmQYASABKA4yFi5maXN0b3MudjEuT2JzZXJ2ZUtpbmQSEQoJc3Vic2NyaWJlGAIgASgIEhMKC3Vuc3Vic2NyaWJlGAMgASgIEhcKD21pbl9pbnRlcnZhbF9tcxgEIAEoDRISCgpkaXNwbGF5X2lkGAUgASgFEg8KB3F1YWxpdHkYBiABKA0SJgoGZm9ybWF0GAcgASgOMhYuZmlzdG9zLnYxLkltYWdlRm9ybWF0IsQBCgZVaU5vZGUSCgoCaWQYASABKAMSEQoJcGFyZW50X2lkGAIgASgDEg0KBWRlcHRoGAMgASgFEhIKCmNsYXNzX25hbWUYBCABKAkSDAoEdGV4dBgFIAEoCRIbChNjb250ZW50X2Rlc2NyaXB0aW9uGAYgASgJEg8KB3ZpZXdfaWQYByABKAkSDAoEaGludBgIIAEoCRIfCgZib3VuZHMYCSABKAsyDy5maXN0b3MudjEuUmVjdBINCgVmbGFncxgKIAEoDSKbAQoOVWlUcmVlU25hcHNob3QSEgoKZGlzcGxheV9pZBgBIAEoBRIUCgxwYWNrYWdlX25hbWUYAiABKAkSFAoMd2luZG93X3RpdGxlGAMgASgJEhQKDHRpbWVzdGFtcF9tcxgEIAEoAxIgCgVub2RlcxgFIAMoCzIRLmZpc3Rvcy52MS5VaU5vZGUSEQoJdHJ1bmNhdGVkGAYgASgIIqwBCgpTY3JlZW5zaG90EhIKCmRpc3BsYXlfaWQYASABKAUSJgoGZm9ybWF0GAIgASgOMhYuZmlzdG9zLnYxLkltYWdlRm9ybWF0EgwKBGRhdGEYAyABKAwSDQoFd2lkdGgYBCABKA0SDgoGaGVpZ2h0GAUgASgNEh8KF2NvbnRhaW5zX3NlY3VyZV9jb250ZW50GAYgASgIEhQKDHRpbWVzdGFtcF9tcxgHIAEoAypiCgtPYnNlcnZlS2luZBIcChhPQlNFUlZFX0tJTkRfVU5TUEVDSUZJRUQQABIYChRPQlNFUlZFX0tJTkRfVUlfVFJFRRABEhsKF09CU0VSVkVfS0lORF9TQ1JFRU5TSE9UEAIq8wIKClVpTm9kZUZsYWcSFQoRVUlfTk9ERV9GTEFHX05PTkUQABIaChZVSV9OT0RFX0ZMQUdfQ0xJQ0tBQkxFEAESHwobVUlfTk9ERV9GTEFHX0xPTkdfQ0xJQ0tBQkxFEAISGwoXVUlfTk9ERV9GTEFHX1NDUk9MTEFCTEUQBBIZChVVSV9OT0RFX0ZMQUdfRURJVEFCTEUQCBIaChZVSV9OT0RFX0ZMQUdfQ0hFQ0tBQkxFEBASGAoUVUlfTk9ERV9GTEFHX0NIRUNLRUQQIBIYChRVSV9OT0RFX0ZMQUdfRU5BQkxFRBBAEhkKFFVJX05PREVfRkxBR19GT0NVU0VEEIABEhoKFVVJX05PREVfRkxBR19TRUxFQ1RFRBCAAhIaChVVSV9OT0RFX0ZMQUdfUEFTU1dPUkQQgAQSGQoUVUlfTk9ERV9GTEFHX1ZJU0lCTEUQgAgSGwoWVUlfTk9ERV9GTEFHX0ZPQ1VTQUJMRRCAEGIGcHJvdG8z", [file_common]);
/**
 * Describes the message fistos.v1.ObserveRequest.
 * Use `create(ObserveRequestSchema)` to create a new message.
 */
export const ObserveRequestSchema = /*@__PURE__*/ messageDesc(file_observe, 0);
/**
 * Describes the message fistos.v1.UiNode.
 * Use `create(UiNodeSchema)` to create a new message.
 */
export const UiNodeSchema = /*@__PURE__*/ messageDesc(file_observe, 1);
/**
 * Describes the message fistos.v1.UiTreeSnapshot.
 * Use `create(UiTreeSnapshotSchema)` to create a new message.
 */
export const UiTreeSnapshotSchema = /*@__PURE__*/ messageDesc(file_observe, 2);
/**
 * Describes the message fistos.v1.Screenshot.
 * Use `create(ScreenshotSchema)` to create a new message.
 */
export const ScreenshotSchema = /*@__PURE__*/ messageDesc(file_observe, 3);
/**
 * @generated from enum fistos.v1.ObserveKind
 */
export var ObserveKind;
(function (ObserveKind) {
    /**
     * @generated from enum value: OBSERVE_KIND_UNSPECIFIED = 0;
     */
    ObserveKind[ObserveKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: OBSERVE_KIND_UI_TREE = 1;
     */
    ObserveKind[ObserveKind["UI_TREE"] = 1] = "UI_TREE";
    /**
     * @generated from enum value: OBSERVE_KIND_SCREENSHOT = 2;
     */
    ObserveKind[ObserveKind["SCREENSHOT"] = 2] = "SCREENSHOT";
})(ObserveKind || (ObserveKind = {}));
/**
 * Describes the enum fistos.v1.ObserveKind.
 */
export const ObserveKindSchema = /*@__PURE__*/ enumDesc(file_observe, 0);
/**
 * Bit flags for UiNode.flags.
 *
 * @generated from enum fistos.v1.UiNodeFlag
 */
export var UiNodeFlag;
(function (UiNodeFlag) {
    /**
     * @generated from enum value: UI_NODE_FLAG_NONE = 0;
     */
    UiNodeFlag[UiNodeFlag["NONE"] = 0] = "NONE";
    /**
     * @generated from enum value: UI_NODE_FLAG_CLICKABLE = 1;
     */
    UiNodeFlag[UiNodeFlag["CLICKABLE"] = 1] = "CLICKABLE";
    /**
     * @generated from enum value: UI_NODE_FLAG_LONG_CLICKABLE = 2;
     */
    UiNodeFlag[UiNodeFlag["LONG_CLICKABLE"] = 2] = "LONG_CLICKABLE";
    /**
     * @generated from enum value: UI_NODE_FLAG_SCROLLABLE = 4;
     */
    UiNodeFlag[UiNodeFlag["SCROLLABLE"] = 4] = "SCROLLABLE";
    /**
     * @generated from enum value: UI_NODE_FLAG_EDITABLE = 8;
     */
    UiNodeFlag[UiNodeFlag["EDITABLE"] = 8] = "EDITABLE";
    /**
     * @generated from enum value: UI_NODE_FLAG_CHECKABLE = 16;
     */
    UiNodeFlag[UiNodeFlag["CHECKABLE"] = 16] = "CHECKABLE";
    /**
     * @generated from enum value: UI_NODE_FLAG_CHECKED = 32;
     */
    UiNodeFlag[UiNodeFlag["CHECKED"] = 32] = "CHECKED";
    /**
     * @generated from enum value: UI_NODE_FLAG_ENABLED = 64;
     */
    UiNodeFlag[UiNodeFlag["ENABLED"] = 64] = "ENABLED";
    /**
     * @generated from enum value: UI_NODE_FLAG_FOCUSED = 128;
     */
    UiNodeFlag[UiNodeFlag["FOCUSED"] = 128] = "FOCUSED";
    /**
     * @generated from enum value: UI_NODE_FLAG_SELECTED = 256;
     */
    UiNodeFlag[UiNodeFlag["SELECTED"] = 256] = "SELECTED";
    /**
     * @generated from enum value: UI_NODE_FLAG_PASSWORD = 512;
     */
    UiNodeFlag[UiNodeFlag["PASSWORD"] = 512] = "PASSWORD";
    /**
     * @generated from enum value: UI_NODE_FLAG_VISIBLE = 1024;
     */
    UiNodeFlag[UiNodeFlag["VISIBLE"] = 1024] = "VISIBLE";
    /**
     * @generated from enum value: UI_NODE_FLAG_FOCUSABLE = 2048;
     */
    UiNodeFlag[UiNodeFlag["FOCUSABLE"] = 2048] = "FOCUSABLE";
})(UiNodeFlag || (UiNodeFlag = {}));
/**
 * Describes the enum fistos.v1.UiNodeFlag.
 */
export const UiNodeFlagSchema = /*@__PURE__*/ enumDesc(file_observe, 1);
